/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metrics_CommitsInputs */



/**
* | output |
* | --- |
* | "commits" |
*
* @param {Metrics_CommitsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metrics_commits = /** @type {((inputs?: Metrics_CommitsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metrics_CommitsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("commits")
});